import React, { useEffect, useState } from "react";
import HomePackages from "./HomePackages";
import { Box, Typography, Button, Container, useMediaQuery, useTheme, Grid } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { getPackagesPrices } from "../api/priceApi";


const HomePackagesLayout = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Detect tablet
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [packagesPrices, setPackagesPrices] = useState([]);

    const packageFeatures = {
        Basic: ["Calendar", "Contact", "Countdown", "Navigation", "Song", "Wish"],
        Standard: ["Calendar", "Contact", "Countdown", "Navigation", "Song", "Wish", "Effects", "RSVP", "Photo Gallery"],
        Premium: ["Calendar", "Contact", "Countdown", "Navigation", "Song", "Wish", "Effects", "RSVP", "Photo Gallery", "QR Bank", "Gift Wishlist", "Weather Forecast", "Digital Photobooth"]
    };

    useEffect(() => {
        const fetchPackagesPrices = async () => {
            try {

                const response = await getPackagesPrices();

                const packageOrder = {
                    Basic: 1,
                    Standard: 2,
                    Premium: 3
                };

                const sortedPackages = response.sort(
                    (a, b) =>
                        packageOrder[a.packageType] -
                        packageOrder[b.packageType]
                );

                setPackagesPrices(sortedPackages);
            } catch (error) {
                console.error("Error fetching packages prices:", error);
                setPackagesPrices([]);
            }
        };
        fetchPackagesPrices();
    }, []);


    return (
        <Container sx={{ textAlign: "center", mt: 1 }}>
            <Typography variant="h6" fontWeight={600}>
                Packages
            </Typography>

            {/* Mobile View - Carousel */}
            {isMobile ? (
                <Swiper

                    modules={[Pagination]}
                    spaceBetween={15}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    style={{ paddingBottom: "50px", paddingTop: "20px", "--swiper-pagination-color": "#68D2D2", }}
                >
                    {packagesPrices.map((pkg, index) => (
                        <SwiperSlide key={index} style={{ display: "flex", justifyContent: "center" }}>
                            <HomePackages
                                name={pkg.packageType}
                                price={pkg.basePrice}
                                features={packageFeatures[pkg.packageType] || []}
                                promoPrice={pkg.finalPrice}
                                promoEndDate={pkg.promoEndDate}
                                isPromo={pkg.isPromoActive} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                /* Desktop/Tablet View - Flex Layout */
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: isMobile ? "16px" : isTablet ? "30px" : "60px", // Adjusts spacing per view
                        mt: 2,
                        px: isMobile ? "16px" : isTablet ? "60px" : "0px",
                    }}
                >
                    {packagesPrices.map((pkg, index) => (
                        <Box key={index} sx={{ maxWidth: "320px", textAlign: "center" }}>
                            <HomePackages
                                name={pkg.packageType}
                                price={pkg.basePrice}
                                features={packageFeatures[pkg.packageType] || []}
                                promoPrice={pkg.finalPrice}
                                promoEndDate={pkg.promoEndDate}
                                isPromo={pkg.isPromoActive}
                            />
                        </Box>
                    ))}
                </Box>
            )}


        </Container>
    );
};

export default HomePackagesLayout;
